import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { billingApi } from './endpoints';

export function useBilling() {
  return useQuery({ queryKey: ['billing'], queryFn: () => billingApi.overview(), retry: false });
}

export function useBillingCheckout() {
  return useMutation({
    mutationFn: ({ body, idempotencyKey }: { body: unknown; idempotencyKey: string }) =>
      billingApi.checkout(body, idempotencyKey),
  });
}

export function useBillingCancellation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (idempotencyKey: string) => billingApi.cancel(idempotencyKey),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['billing'] });
    },
  });
}
